package com.ustadmobile.core.io.ext

import com.ustadmobile.lib.db.entities.ContainerEntryFile

actual suspend fun ContainerEntryFile.getStringFromContainerEntry(): String {
    TODO("Not yet implemented")
}